import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box, InputAdornment, TextField } from '@mui/material';
import { Card } from './Card';

/**
 * Disposition commune des pages « liste » de l'ERP (modèle : Joueurs) :
 *   <PageContainer fill>
 *     <PageHeader title actions={[actions secondaires (outlined)…, bouton principal « Nouveau … » (contained, AddIcon)]} />
 *     <FilterBar end={filtres + réinitialiser}> <SearchField … /> </FilterBar>
 *     <TableCard title={« 12 joueurs »} icon> <DataGrid sx={{ height: '100%' }} /> </TableCard>
 *   </PageContainer>
 * Le tableau prend toute la hauteur restante et défile en interne : la page elle-même ne défile pas.
 */

/** Champ de recherche standard d'une liste (à gauche de la FilterBar). */
export function SearchField({ value, onChange, placeholder = 'Rechercher', sx, ...rest }) {
  return (
    <TextField
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{ flex: '1 1 320px', maxWidth: 520, ...sx }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ fontSize: 18 }} />
            </InputAdornment>
          ),
        },
        htmlInput: { 'aria-label': placeholder },
      }}
      {...rest}
    />
  );
}

/**
 * Carte d'un tableau qui remplit la hauteur de la page. Le contenu est posé dans une zone absolue : sa hauteur vient
 * de la page, jamais du contenu (la zone principale de l'ERP n'a qu'une hauteur minimale, un contenu « naturel »
 * ferait défiler toute la page). Un DataGrid y prend `height: '100%'` ; une liste maison y défile (`overflow: auto`).
 * `top` / `bottom` : bandes fixes au-dessus / au-dessous de la zone qui défile (barre de chargement, pagination).
 */
export function TableCard({ children, top, bottom, sx, minHeight = 360, ...cardProps }) {
  return (
    <Card padding={false} {...cardProps} sx={{ flex: 1, minHeight, ...sx }}>
      {top}
      <Box sx={{ flex: 1, minHeight: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', inset: 0, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>{children}</Box>
      </Box>
      {bottom}
    </Card>
  );
}
